import { render, staticRenderFns } from "./AlacakliCardList.vue?vue&type=template&id=4440c52d"
import script from "./AlacakliCardList.vue?vue&type=script&lang=ts"
export * from "./AlacakliCardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports